export const USE_SITE_MERGE_TOOL_LINK =
  'is already in use by another site resolve this by using the '



// WEBPACK FOOTER //
// ./src/components/EditSiteModal/constants.js